import PencilOutline from '@simplywallst/ui-core/icons/PencilOutline';
import { CompanyIntrinsicDiscount } from '@/components/CompanyIntrinsicDiscount';
import { isNil } from '@/utilities/format';
import { toCurrencyTruncated } from '@/utilities/formatting';
import type { CurrencyISO } from '@/constants/currencies';

type SelectNarrativeBtnProps = {
  onClick: () => void;
};

const SelectNarrativeBtn = ({ onClick }: SelectNarrativeBtnProps) => {
  return (
    <span
      className="grid cursor-pointer grid-cols-[max-content_max-content] items-center gap-1"
      onClick={onClick}
    >
      <span className="m-0 text-xs text-accent">Select narrative</span>
      <PencilOutline className="size-x2 fill-accent" />
    </span>
  );
};

type Props = {
  currencyISO: CurrencyISO | null;
  fairValue: number | null;
  npvPerShare: number | null;
  onClick: () => void;
  sharePrice: number | null;
};

export const PopulatedState = ({
  currencyISO,
  fairValue,
  npvPerShare,
  onClick,
  sharePrice,
}: Props) => {
  const formattedFairValue = toCurrencyTruncated(
    fairValue || 0,
    2,
    currencyISO ?? 'XXX'
  );
  const isFairValueValid = !isNil(fairValue);

  return (
    <div className="grid grid-cols-[auto_1fr] gap-2">
      <div className="mt-1.5 size-2 rounded-full bg-chart-03"></div>
      <div>
        <div className="mb-1 grid grid-cols-[1fr_auto] gap-2">
          <div>
            <p className="m-0 text-xs text-soft">Fair Value</p>
          </div>
          {isFairValueValid && <SelectNarrativeBtn onClick={onClick} />}
        </div>
        <div className="grid grid-cols-[max-content_auto] items-center gap-2">
          {isFairValueValid ? (
            <>
              <p className="m-0 text-xs text-solid">{formattedFairValue}</p>
              <div className="text-tiny">
                <CompanyIntrinsicDiscount
                  fairValue={fairValue}
                  lastSharePrice={sharePrice}
                  npvPerShare={npvPerShare}
                />
              </div>
            </>
          ) : (
            <SelectNarrativeBtn onClick={onClick} />
          )}
        </div>
      </div>
    </div>
  );
};
